import {
    GEO_DATA_REQUEST,
    GEO_DATA_SUCCESS,
    GEO_DATA_FAILURE,
    PROVIDER_DATA_REQUEST,
    PROVIDER_DATA_SUCCESS,
    PROVIDER_DATA_FAILURE,
    LOOKUP_DATA_REQUEST,
    LOOKUP_DATA_SUCCESS,
    LOOKUP_DATA_FAILURE,
    TEXT_DATA_REQUEST,
    TEXT_DATA_SUCCESS,
    TEXT_DATA_FAILURE,
    LOOKUP_REFERENCE_DATA_REQUEST,
    LOOKUP_REFERENCE_DATA_SUCCESS,
    LOOKUP_REFERENCE_DATA_FAILURE,
    SERVICE_DATA_REQUEST,
    SERVICE_DATA_SUCCESS,
    SERVICE_DATA_FAILURE,

} from '../actions/commonDataActions';

import {RSAA} from 'redux-api-middleware';

const geoResource = {
    resource: "/common/geo",
    contentType: "application/json"
};

const providerResource = {
    resource: "/organization"
};

const lookupResource = {
    resource: "/admin/lookup",
    contentType: "application/json"
};

const textResource = {
    resource: "/admin/text",
    contentType: "application/json"
};

const lookupResourceReference = {
    resource: "/admin/lookupReference",
    contentType: "application/json"
};

const serviceResource = {
    resource: '/admin/services',
    contentType: 'application/json'
};

export function fetchGeoData() {
    return {
        [RSAA]: {
            endpoint: geoResource.resource,
            method: 'GET',
            types: [
                GEO_DATA_REQUEST, {
                    type: GEO_DATA_SUCCESS,
                    payload: (action, state, res) => {
                        return res.json().then((json) => mapGeoData(json));
                    }
                },
                GEO_DATA_FAILURE
            ]
        }
    }
}

export function fetchProviderData() {
    return {
        [RSAA]: {
            endpoint: providerResource.resource,
            method: 'GET',
            types: [
                PROVIDER_DATA_REQUEST, {
                    type: PROVIDER_DATA_SUCCESS,
                    payload: (action, state, res) => {
                        return res.json().then((json) => mapProviderData(json));
                    }
                },
                PROVIDER_DATA_FAILURE
            ]
        }
    }
}

export function fetchLookupData() {
    return {
        [RSAA]: {
            endpoint: lookupResource.resource,
            method: 'GET',
            types: [
                LOOKUP_DATA_REQUEST, {
                    type: LOOKUP_DATA_SUCCESS,
                    payload: (action, state, res) => {
                        return res.json().then((json) => mapLookupData(json));
                    }
                },
                LOOKUP_DATA_FAILURE
            ]
        }
    }
}

export function fetchTextData() {
    return {
        [RSAA]: {
            endpoint: textResource.resource,
            method: 'GET',
            types: [
                TEXT_DATA_REQUEST, {
                    type: TEXT_DATA_SUCCESS,
                    payload: (action, state, res) => {
                        return res.json().then((json) => MapTextData(json));
                    }
                },
                TEXT_DATA_FAILURE
            ]
        }
    }
}

export function fetchLookupReferenceData() {
    return {
      [RSAA]: {
        endpoint: lookupResourceReference.resource,
        method: 'GET',
        types: [
          LOOKUP_REFERENCE_DATA_REQUEST, {
            type: LOOKUP_REFERENCE_DATA_SUCCESS,
            payload: (action, state, res) => {
              return res
                        .json()
                        .then((json) => mapLookupReferenceData(json));
            }
          },
          LOOKUP_REFERENCE_DATA_FAILURE
        ]
      }
    }
}

function MapTextData(json) {
    let returnVal = {};
    json.textItems.forEach((t) => {
        //create type branch
        if (!returnVal[t.textType]) {
            returnVal[t.textType] = [];
        }
        t.portalTypes.forEach((pt)=>{
            //create portal type branch
          if(!returnVal[t.textType][pt]){
            returnVal[t.textType][pt] = []
          }
          //add text elment to portaltype branch
          returnVal[t.textType][pt].push(t);
        });
    });
    return returnVal;
}

function mapGeoData(json) {
    let returnVal = [];
    json.countries.forEach((c) => {
        returnVal[c.code] = {
            ...c
        }
    });
    returnVal.sort((a, b) => {
        const aKey = a.order;
        const bKey = b.order;
        return aKey > bKey;
    });
    return returnVal;
}

function mapLookupData(json) {
    let returnVal = [];
    json.lookups.forEach((l) => {
        if (!returnVal[l.category]) {
            returnVal[l.category] = [];
        }
        returnVal[l.category].push({name: l.name, value: l.value, order: l.order, viewable: l.viewable, groups: l.groups});
        returnVal[l.category].sort((a, b) => {
            const aKey = a.order;
            const bKey = b.order;
            return aKey > bKey;
        });
    });
    return returnVal;
}

function mapProviderData(json) {
    let returnVal = [];
    json.organizations.forEach((p) => {
        if (!returnVal[p.stateCd]) {
            returnVal[p.stateCd] = [];
        }
        returnVal[p.stateCd].push({name: p.schoolName, id: p.id, schoolId: p.schoolId, cat4Eligible: p.cat4Eligible, stateCode: p.stateCd, status: p.status})
    });

    return returnVal;
}

function mapLookupReferenceData(json) {
    let returnVal = [];
    json.lookupReferences.forEach((r) => {
    returnVal.push({lookupValue: r.lookupValue, lookupDescription: r.lookupDescription, type: r.type, description: r.description});
    });
    return returnVal;
}

export function fetchServices() {
    return {
      [RSAA]: {
        endpoint: serviceResource.resource,
        method: 'GET',
        types: [
          SERVICE_DATA_REQUEST, {
            type: SERVICE_DATA_SUCCESS,
            payload: (action, state, res) => {
              return res.json().then((json) => mapServiceData(json));
            }
          },
          SERVICE_DATA_FAILURE
        ]
      }
    }
  }

  function mapServiceData(json) {
    let returnVal = [];
    json.services.forEach((r) => {
        returnVal.push({createdDate: r.createdDate, modifiedDate: r.modifiedDate, serviceName: r.serviceName, description: r.description, price : r.price});
    });
    return returnVal;
  }

